import { LayoutGrid } from "lucide-react";
import { useKoncepty } from "@/api/hooks/useTopsolidKoncept";
import { usePrava } from "@/api/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { useImport } from "@/lib/import/ImportContext";

/**
 * Pás v editore zákazky pre rozpočtára (KOLO 232): obchodník vložil regál CRC
 * a diely, ktoré vyrába Tandem, čakajú v rozrobenom importe na nacenenie.
 * User: *„rozpočtárovi to ukáže, že aha, treba naceniť“*. Koncept vidí len ten,
 * kto smie upravovať nábytok (server), takže obchodník pás nemá.
 */
export function PasRegalNacenit({ zakazkaId }: { zakazkaId: string }): JSX.Element | null {
  const prava = usePrava();
  const koncepty = useKoncepty();
  const { otvorKoncept } = useImport();
  if (prava.nabytok !== "vsetko") return null;
  const regal = (koncepty.data?.data ?? []).filter(
    (k) => k.zdroj === "regal" && k.zakazka_id === zakazkaId,
  );
  const k = regal[0];
  if (!k) return null;
  return (
    <div
      className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border border-amber-300 bg-amber-50 px-3 py-1.5 text-sm dark:border-amber-700 dark:bg-amber-950/30"
      data-testid="pas-regal-nacenit"
    >
      <LayoutGrid className="h-4 w-4 shrink-0 text-amber-700" />
      <span className="min-w-0 flex-1">
        <b>Regál CRC</b> od {k.autor || "obchodníka"}: diely Tandemu treba naceniť
        {k.dielcov ? ` (${k.dielcov} dielcov)` : ""} — pribudnú do nábytku ako nové zostavy.
      </span>
      <Button size="sm" className="h-7" onClick={() => otvorKoncept(k.id)}>
        Otvoriť import
      </Button>
    </div>
  );
}
